<div class="ap-header__navigation vertical-navigation-item vertical-navigation-item--submenu-header">
    @if (navigationItem().type === navigationType.PARENT) {
        <a
            tabindex="0"
            (keydown.enter)="backClicked.emit()"
            (keydown.space)="backClicked.emit()"
            (click)="backClicked.emit()"
            [attr.aria-label]="navigationItem().ariaLabel"
        >
            <ap-icon
                class="ap-header__navigation-chevron--left"
                name="chevron-left"
                color="inherit"
                size="small"
                data-testid="icon-chevron-left"
            >
            </ap-icon>
            {{ navigationItem().label }}
        </a>
    }
    @if (navigationItem().type === navigationType.PARENT_ICON) {
        <ap-action-icon class="ap-header__navigation-icon" [ariaLabel]="navigationItem().ariaLabel" (click)="backClicked.emit()">
            <ap-icon class="ap-header__navigation-chevron--left" name="chevron-left" color="inherit" size="small"></ap-icon>
            <ap-icon [name]="navigationItem().iconName" size="large"></ap-icon>
        </ap-action-icon>
    }
</div>

@for (navigationItem of navigationItem().children; track navigationItem; let last = $last) {
    <ap-vertical-navigation-item
        [navigationItem]="navigationItem"
        [isLastItem]="last"
        (navigationClicked)="navigationClicked.emit(navigationItem)"
    ></ap-vertical-navigation-item>
}
